import { render, staticRenderFns } from "./yi-goods-action.vue?vue&type=template&id=b7f1d036&"
import script from "./yi-goods-action.vue?vue&type=script&lang=js&"
export * from "./yi-goods-action.vue?vue&type=script&lang=js&"
import style0 from "./yi-goods-action.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "src/components/yi-goods-action/yi-goods-action.vue"
export default component.exports